import { render, staticRenderFns } from "./HistoryTab.vue?vue&type=template&id=4309a39e"
import script from "./HistoryTab.vue?vue&type=script&lang=js"
export * from "./HistoryTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports